// ==================================
// Servicio de Super Admins
// ==================================

import api from './api';
import type {
  SuperAdmin,
  CrearSuperAdminInput,
  ActualizarSuperAdminInput,
  FiltrosSuperAdmins,
  RespuestaPaginada,
  ApiResponse,
} from '@/tipos';

export const superadminsServicio = {
  listar: async (filtros: FiltrosSuperAdmins = {}): Promise<RespuestaPaginada<SuperAdmin>> => {
    const params = new URLSearchParams();
    if (filtros.busqueda) params.append('busqueda', filtros.busqueda);
    if (filtros.estado) params.append('estado', filtros.estado);
    if (filtros.pagina) params.append('pagina', filtros.pagina.toString());
    if (filtros.limite) params.append('limite', filtros.limite.toString());
    const response = await api.get<ApiResponse<RespuestaPaginada<SuperAdmin>>>(
      `/admin/superadmins?${params.toString()}`
    );
    return response.data.data;
  },

  obtenerPorId: async (id: string): Promise<SuperAdmin> => {
    const response = await api.get<ApiResponse<SuperAdmin>>(`/admin/superadmins/${id}`);
    return response.data.data;
  },

  crear: async (data: CrearSuperAdminInput): Promise<SuperAdmin> => {
    const response = await api.post<ApiResponse<SuperAdmin>>('/admin/superadmins', data);
    return response.data.data;
  },

  actualizar: async (id: string, data: ActualizarSuperAdminInput): Promise<SuperAdmin> => {
    const response = await api.patch<ApiResponse<SuperAdmin>>(`/admin/superadmins/${id}`, data);
    return response.data.data;
  },

  cambiarPassword: async (id: string, passwordNuevo: string): Promise<void> => {
    await api.patch(`/admin/superadmins/${id}/password`, { passwordNuevo });
  },

  eliminar: async (id: string): Promise<void> => {
    await api.delete(`/admin/superadmins/${id}`);
  },
};

export default superadminsServicio;
